import * as React from "react";

type HamburgerMenuProps = {
  isOpen: boolean;
};

const HamburgerMenu: React.FC<HamburgerMenuProps> = ({ isOpen }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
    >
      {/* Top bar */}
      <rect
        x="3"
        y="6"
        width="18"
        height="2"
        rx="1"
        fill="currentColor"
        className="transition-all duration-400 ease-in-out"
        style={{
          transformOrigin: "center",
          transform: isOpen
            ? "rotate(45deg) translate(0px, 5px)"
            : "rotate(0deg) translate(0px, 0px)",
        }}
      />

      {/* Middle bar */}
      <rect
        x="3"
        y="11"
        width="18"
        height="2"
        rx="1"
        fill="currentColor"
        className="transition-all duration-400 ease-in-out"
        style={{
          opacity: isOpen ? 0 : 1,
        }}
      />

      {/* Bottom bar */}
      <rect
        x="3"
        y="16"
        width="18"
        height="2"
        rx="1"
        fill="currentColor"
        className="transition-all duration-400 ease-in-out"
        style={{
          transformOrigin: "center",
          transform: isOpen
            ? "rotate(-45deg) translate(0px, -5px)"
            : "rotate(0deg) translate(0px, 0px)",
        }}
      />
    </svg>
  );
};

export default HamburgerMenu;
